import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './auth/AuthProvider';
import { ToastProvider } from './components/Toasts';
import { ConnectionProvider } from './lib/ConnectionProvider';
import { registerServiceWorker } from './lib/serviceWorker';
import './styles/global.css';

const container = document.getElementById('root');
if (!container) throw new Error('Elemento #root mancante in index.html');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <ConnectionProvider>
        <ToastProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ToastProvider>
      </ConnectionProvider>
    </BrowserRouter>
  </StrictMode>,
);

registerServiceWorker();
